var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: _vm.dialogVisivel,
      callback: function ($$v) {
        _vm.dialogVisivel = $$v;
      },
      expression: "dialogVisivel"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-school")]), _vm._v(" Confirmação de Presença em Formação ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "mt-5"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.formacaoAtual.nome,
      "label": "Formação",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.formacaoAtual.cargaHoraria,
      "label": "Carga Horária",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.formacaoAtual.dataRealizacao,
      "label": "Data de Realização",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.formacaoAtual.localRealizacao,
      "label": "Local de Realização",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "mb-2 font-weight-medium"
  }, [_vm._v("Instrutor(es)")]), _c('v-chip-group', {
    attrs: {
      "column": ""
    }
  }, _vm._l(_vm.formacaoAtual.instrutores, function (instrutor, index) {
    return _c('v-chip', {
      key: index,
      attrs: {
        "color": "primary",
        "dark": ""
      }
    }, [_vm._v(" " + _vm._s(instrutor) + " ")]);
  }), 1)], 1)], 1), _c('v-container', {
    staticClass: "px-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-checkbox', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', [_vm._v(" Eu "), _c('strong', [_vm._v(_vm._s(_vm.$user.fullName))]), _vm._v(", CPF "), _c('strong', [_vm._v(_vm._s(_vm.$formatCpf(_vm.$user.username)))]), _vm._v(", declaro, sob minha responsabilidade, que a confirmação de presença nesta formação foi realizada de forma consciente e verdadeira, estando plenamente ciente das implicações decorrentes desta declaração. ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.checkbox,
      callback: function ($$v) {
        _vm.checkbox = $$v;
      },
      expression: "checkbox"
    }
  })], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": 'Confirmar Presença',
      "cancelText": 'Confirmar Ausência'
    },
    on: {
      "click": function ($event) {
        return _vm.confirmarPresenca(true);
      },
      "cancel": function ($event) {
        return _vm.confirmarPresenca(false);
      }
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }